/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState} from 'react';
import {useInputValue} from '../../../utils/hooks/useInputValue';
import {AdBodyForm, AdBodyFormUp, AdFooter, RadiosContainer} from '../styles';
import {InputComponent, Label, LargeButton, Loader, PowerInput, Radio, TextWarning} from '../../../components';
import {AdBodyFormRole, AdBodyFormSearch} from '../addCoaches/styles';
import {EdBody} from '../editPlayers/styles';
import {Teams, Utils} from '../../../utils/api';
import {ARMcontext} from '../../../utils/context/context';

export const IndividualCoach = ({teamMemo, item, index, useSelectedPlayers, useError}) => {
  const [sponsor, useSponsor] = useState<any>(item.role === 'Admin' ? {one: true, two: false} : {one: false, two: true});
  const emailName = useInputValue(item.email, '', 'normal', '', 'email');
  const [team, useTeam] = useState<any>(Boolean(item?.teams.length) ? item?.teams : item.role === 'Coach' ? [teamMemo[0]] : []);
  const firstName = useInputValue(item.firstName);
  const lastName = useInputValue(item.lastName);
  const UTILS = new Utils();
  const isValidInput = UTILS.GetValidationInputPattern();
  const isValidEmail = UTILS.GetValidationEmailPattern();

  useEffect(() => {
    if (!Boolean(firstName.value.length)) {
      firstName.HandleWarning('This field cannot be empty');
      firstName.HandleStatus('error');
      useError(prev => {
        if (Boolean(prev.filter(el => el.index === 1).length)) {
          return prev;
        } else {
          return [...prev, {index: 1}];
        }
      });
    } else if (!isValidInput.test(firstName.value)) {
      firstName.HandleWarning('This field does not allow special characters');
      firstName.HandleStatus('error');
      useError(prev => {
        if (Boolean(prev.filter(el => el.index === 1).length)) {
          return prev;
        } else {
          return [...prev, {index: 1}];
        }
      });
    } else {
      firstName.HandleWarning('');
      firstName.HandleStatus('normal');
      useError(prev => {
        return prev.filter(el => el.index !== 1);
      });
    }
    infoChange({firstName: firstName.value});
  }, [firstName.value]);

  useEffect(() => {
    if (!Boolean(lastName.value.length)) {
      lastName.HandleWarning('This field cannot be empty');
      lastName.HandleStatus('error');
      useError(prev => {
        if (Boolean(prev.filter(el => el.index === 2).length)) {
          return prev;
        } else {
          return [...prev, {index: 2}];
        }
      });
    } else if (!isValidInput.test(lastName.value)) {
      lastName.HandleWarning('This field does not allow special characters');
      lastName.HandleStatus('error');
      useError(prev => {
        if (Boolean(prev.filter(el => el.index === 2).length)) {
          return prev;
        } else {
          return [...prev, {index: 2}];
        }
      });
    } else {
      lastName.HandleWarning('');
      lastName.HandleStatus('normal');
      useError(prev => {
        return prev.filter(el => el.index !== 2);
      });
    }
    infoChange({lastName: lastName.value});
  }, [lastName.value]);

  useEffect(() => {
    if (!Boolean(emailName.value.length)) {
      emailName.HandleWarning('This field cannot be empty');
      emailName.HandleStatus('error');
      useError(prev => {
        if (Boolean(prev.filter(el => el.index === 3).length)) {
          return prev;
        } else {
          return [...prev, {index: 3}];
        }
      });
    } else if (!isValidEmail.test(emailName.value)) {
      emailName.HandleWarning('Invalid email');
      emailName.HandleStatus('error');
      useError(prev => {
        if (Boolean(prev.filter(el => el.index === 3).length)) {
          return prev;
        } else {
          return [...prev, {index: 3}];
        }
      });
    } else {
      emailName.HandleWarning('');
      emailName.HandleStatus('normal');
      useError(prev => {
        return prev.filter(el => el.index !== 3);
      });
    }
    infoChange({email: emailName.value});
  }, [emailName.value]);

  function AlternateFocus(hook: any) {
    hook.HandleStatus('normal');
    hook.HandleWarning('');
  }

  function AddTeam(selectedTeam: any): void {
    useTeam(prev => {
      if (Boolean(prev.filter(el => el.badge === 'ALL').length)) {
        const modTeams = [...prev];
        infoChange({team: modTeams});
        return modTeams;
      } else if (Boolean(prev.length) && selectedTeam.badge === 'ALL') {
        const modTeams = [...prev];
        infoChange({team: modTeams});
        return modTeams;
      } else if (!Boolean(prev.filter(el => selectedTeam._id === el._id).length)) {
        const modTeams = [...prev, selectedTeam];
        infoChange({team: modTeams});
        return modTeams;
      } else {
        const modTeams = [...prev];
        infoChange({team: modTeams});
        return modTeams;
      }
    });
  }

  function HandleRadiosSponsor(e: any): void {
    if (e.target.id === `${index}-admin`) {
      useSponsor({one: true, two: false});
      infoChange({sponsor: {one: true, two: false}});
    } else if (e.target.id === `${index}-coach`) {
      useSponsor({one: false, two: true});
      infoChange({sponsor: {one: false, two: true}});
    }
  }

  function handleCancelBadge(element) {
    const teamData = [...team.filter(el => element._id !== el._id)];
    useTeam(teamData);
    infoChange({team: teamData});
  }

  function infoChange({
    team,
    email,
    sponsor,
    position,
    lastName,
    firstName,
  }: {
    email?: string;
    lastName?: string;
    firstName?: string;
    team?: object | any;
    sponsor?: object | any;
    position?: Array<any> | any;
  }) {
    useSelectedPlayers(prev => [
      ...prev.map((el, id) => {
        if (id !== index) {
          return el;
        } else {
          if (firstName) {
            el.firstName = firstName;
          }
          if (lastName) {
            el.lastName = lastName;
          }
          if (team) {
            el.team = team;
          }
          if (position) {
            el.position = position;
          }
          if (email) {
            el.email = email;
          }
          if (sponsor) {
            el.sponsor = sponsor;
          }
          return el;
        }
      }),
    ]);
  }

  return (
    <AdBodyForm data-cy="editCoaches-form">
      <AdBodyFormUp>
        <div>
          <Label text="FIRST NAME" fontWeight="600" fontSize="12px" />
          <InputComponent dynamicSearch={firstName} animateWidth="90%" HandleFocus={() => AlternateFocus(firstName)} />
          <TextWarning status={firstName.status} message={firstName.warningMessage} display="block" />
        </div>
        <div>
          <Label text="LAST NAME" fontWeight="600" fontSize="12px" />
          <InputComponent dynamicSearch={lastName} animateWidth="90%" HandleFocus={() => AlternateFocus(lastName)} />
          <TextWarning status={lastName.status} message={lastName.warningMessage} display="block" />
        </div>
        <div>
          <Label text="EMAIL" fontWeight="600" fontSize="12px" />
          <InputComponent dynamicSearch={emailName} animateWidth="90%" HandleFocus={() => AlternateFocus(emailName)} />
          <TextWarning status={emailName.status} message={emailName.warningMessage} display="block" />
        </div>
      </AdBodyFormUp>
      {sponsor.two && (
        <AdBodyFormSearch>
          <Label text="TEAM" fontWeight="600" fontSize="12px" />
          <PowerInput search={true} onClick={AddTeam} dataArray={teamMemo} selectedTeams={team} handleCancel={handleCancelBadge} placeholder='Choose your team'/>
        </AdBodyFormSearch>
      )}
      <AdBodyFormRole>
        <Label text="ROLE" fontWeight="600" fontSize="12px" />
        <RadiosContainer onChange={HandleRadiosSponsor}>
          <Radio
            title="Admin"
            name="tableInfo"
            id={`${index}-admin`}
            checked={item.role === 'Admin' && true}
            dynamicActive={sponsor.one}
          />
          <Radio
            title="Coach"
            name="tableInfo"
            id={`${index}-coach`}
            checked={item.role !== 'Admin' && false}
            dynamicActive={sponsor.two}
          />
        </RadiosContainer>
      </AdBodyFormRole>
    </AdBodyForm>
  );
};

export default ({teamMemo, handleView, selectedCoaches, useSelectedCoaches}) => {
  const {HandleToastMessage} = useContext(ARMcontext);
  const [error, useError] = useState<Array<any>>([]);
  const [loading, useLoading] = useState(false);
  const TEAMS = new Teams();

  function HandleSubmit() {
    if (!Boolean(error.length)) {
      useLoading(true);
      const invitationIDs = selectedCoaches.map(el => el._id);
      const recoveData = selectedCoaches.map(el => {
        let allCounter = false;
        const teams = el.team
          ?.map(team => team._id)
          ?.map(team => {
            if (team === undefined) {
              allCounter = true;
            }
            return team;
          })
          .filter(team => team !== undefined);
        const roleCalculated = el?.sponsor?.one ? 'Admin' : el?.sponsor?.two ? 'Coach' : el?.role ? el.role : 'Admin';
        const memoryData = {
          coach:el.coach,
          firstName: el.firstName,
          lastName: el.lastName,
          email: el.email,
          teams,
          role: roleCalculated,
          allTeams: roleCalculated === 'Admin' ? true : allCounter,
        };
        return memoryData;
      });
      const results = invitationIDs.map(async (el, idx) => {
        return await TEAMS.UpdateCoachInvitation(el, recoveData[idx]);
      });
      Promise.all(results).then((data) => {
        if(data[0].status){
          HandleToastMessage('Invitations updated', true, 2500, 'success');
        }else{
          HandleToastMessage(data[0].data.message, true, 2500, "error");
        }
        useLoading(false);
        handleView(false);
      });
    }
  }

  return (
    <>
      <EdBody>
        {selectedCoaches.map((el, idx) => (
          <IndividualCoach
            key={idx}
            index={idx}
            teamMemo={teamMemo}
            item={el}
            useSelectedPlayers={useSelectedCoaches}
            useError={useError}
          />
        ))}
      </EdBody>
      <AdFooter>
        <LargeButton
          lMargin="0"
          title="CANCEL"
          rMargin="0 40px"
          rColor="#ffffff"
          lColor="#ffffff"
          fColor="#5D6C76"
          bColor="#F0F0F0"
          xMargin="0 10px 0 0"
          dataCy="editCoaches-cancel"
          callback={() => handleView(false)}
        />
        {loading ? (
          <Loader width="190px" />
        ) : (
          <LargeButton
            icon="done"
            rColor="#007AFF"
            lColor="#006BE1"
            title="SAVE PROFILES"
            callback={HandleSubmit}
            dataCy="editCoaches-submit"
          />
        )}
      </AdFooter>
    </>
  );
};
